import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const subscribeNewsletter = (email) =>
    api.post("/newsletter", { email }).then((r) => r.data);
export const submitServiceRequest = (payload) =>
    api.post("/service-request", payload).then((r) => r.data);
export const submitWholesaleQuote = (payload) =>
    api.post("/wholesale-quote", payload).then((r) => r.data);
